export default __webpack_public_path__ + "static/media/matchesFlag.c2de57b3.svg";